import { render, staticRenderFns } from "./MoveMenuBtn.vue?vue&type=template&id=80c43fae&scoped=true&"
import script from "./MoveMenuBtn.vue?vue&type=script&lang=js&"
export * from "./MoveMenuBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c43fae",
  null
  
)

export default component.exports